{
    "Accessibility Menu": "قائمة إمكانية الوصول",
    "Reset settings": "إعادة تعيين الإعدادات",
    "Close": "إغلاق",
    "Content Adjustments": "تعديلات المحتوى",
    "Adjust Font Size": "تعديل حجم الخط",
    "Highlight Title": "تسليط الضوء على العنوان",
    "Highlight Links": "تسليط الضوء على الروابط",
    "Readable Font": "خط سهل القراءة",
    "Color Adjustments": "تعديلات الألوان",
    "Dark Contrast": "تباين داكن",
    "Light Contrast": "تباين فاتح",
    "High Contrast": "تباين عالي",
    "High Saturation": "تشبع عالي",
    "Low Saturation": "تشبع منخفض",
    "Monochrome": "أحادي اللون",
    "Protanopia": "عمى البروتانوبيا",
    "Deuteranopia": "عمى الديوترانوبيا",
    "Tritanopia": "عمى التريتانوبيا",
    "Visual & Navigation Aids": "المساعدات البصرية والتنقل",
    "Additional Tools": "أدوات إضافية",
    "Reading Guide": "دليل القراءة",
    "Stop Animations": "إيقاف الرسوم المتحركة",
    "Big Cursor": "مؤشر كبير",
    "Screen Reader": "قارئ الشاشة",
    "Hide Images": "إخفاء الصور",
    "Image Tooltips": "تلميحات الصور",
    "Page Structure": "هيكل الصفحة",
    "Super Focus": "تركيز فائق",
    "Magnifier": "مكبّر",
    "Increase Font Size": "زيادة حجم الخط",
    "Decrease Font Size": "تقليل حجم الخط",
    "Letter Spacing": "تباعد الحروف",
    "Line Height": "ارتفاع السطر",
    "Font Weight": "سماكة الخط",
    "Dyslexia Font": "خط القراءة لمن يعانون من عسر القراءة",
    "Language": "اللغة",
    "Open Accessibility Menu": "افتح قائمة الوصول",
    "Accessibility Profiles": "ملفات تعريف إمكانية الوصول",
    "Seizure Safe Profile": "ملف آمن للنوبات",
    "Stops animations and reduces color saturation.": "يوقف الرسوم المتحركة ويقلل تشبع الألوان.",
    "Blind Profile": "ملف المكفوفين",
    "Activates the screen reader for auditory navigation.": "يُفعّل قارئ الشاشة للتنقل السمعي.",
    "Visually Impaired Profile": "ملف ضعاف البصر",
    "Enhances contrast and readability for low vision.": "يحسّن التباين وقابلية القراءة لضعاف البصر.",
    "ADHD Friendly Profile": "ملف مناسب لاضطراب ADHD",
    "Reduces distractions for better focus.": "يقلل المشتتات لتركيز أفضل.",
    "Cognitive & Learning Profile": "ملف المعرفة والتعلم",
    "Helpful tools for reading and comprehension.": "أدوات مفيدة للقراءة والفهم.",
    "Motor Impaired Profile": "ملف الإعاقة الحركية",
    "Optimizes the site for keyboard-only navigation.": "يُحسّن الموقع للتنقل بلوحة المفاتيح فقط.",
    "Headings": "العناوين",
    "Landmarks": "المعالم",
    "Links": "الروابط",
    "Focus element": "تركيز العنصر",
    "Visit link": "زيارة الرابط"
}
